import { IUserData } from 'Container/Ui/interface';
import getApiSettingsHelper from 'Helper/getApiSettings';

/**
 * interface fot fetching a webchat instance
 */
export interface IInitWebchat {
    /**
     * nickName
     */
    nickName: string;
    /**
     * firstName
     */
    firstName: string;
    /**
     * lastName
     */
    lastName: string;
    /**
     * data
     */
    data ?: string;
    /**
     * userData
     */
    userData ?: IUserData;
}

/**
 * initWebchat
 */
export const getApiSettings = (config: IInitWebchat, topic: string) => {
    const params = new URLSearchParams();
    params.append('firstName', config.firstName);
    params.append('lastName', config.lastName);
    params.append('nickName', config.nickName);
    params.append('userData[GCTI_LanguageCode]', 'en');
    params.append('userData[selectedTopic]', topic);
    if (config.userData?.market) {
        params.append('userData[market]', config.userData?.market);
    }
    if (config.userData?.intent) {
        params.append('userData[intent]', config.userData?.intent);
    }

    return getApiSettingsHelper(params);
};
